import React, { useEffect, useState } from "react";

// React lottie
import Lottie from "react-lotties";
import PaperPlane from "../../lotties/paperplane.json";

// Axios and API
import { addTag } from "../../api/addTag";
import { fetchTags } from "../../api/fetchTags";
import { addActivity } from "../../api/addActivity";
import { fetchActivityDetail } from "../../api/fetchActivityDetail";
import { editActivity } from "../../api/editActivity";

// React Datepicker
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Moment.js
import moment from "moment";

// Icons
import uploadImageBtn from "../../images/icons/admin/uploadImageBtn.png";
import addMoreIcon from "../../images/icons/admin/addMoreIcon.png";
import iconChangeImage from "../../images/icons/admin/changeImageIcon.png";
import DeleteIcon from "../../images/icons/DeleteIcon.png";

// Sweet Alert v2
import Swal from "sweetalert2";

// Components
import Loader from "../../components/Loader";
import WorkshopDropdownSelect from "../ISA-Academy-Form/components/WorkshopDropdownSelect";
import ArrowDownIcon from "../../images/icons/admin/arrowDownIcon";
import InputUploadImages from "../../components/InputUploadImages";

function useForceUpdate() {
  const [value, setValue] = useState(0);
  return () => setValue((value) => value + 1);
}

const ActivitiesForm = (props) => {
  const {
    navigate,
    setShowAlertWorkshop,
    setWorkshopAlertMsg,
    editId,
    fetchAllActivities,
  } = props;
  const forceUpdate = useForceUpdate();
  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: PaperPlane,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [tagOptions, setTagOptions] = useState([]);
  const [typeOfActivity, setTypeOfActivity] = useState(null);
  const [tags, setTags] = useState([]);
  const [activityDate, setActivityDate] = useState(null);
  const [selectedActivityDate, setSelectedActivityDate] = useState(null);
  const [activityTitle, setActivityTitle] = useState("");
  const [activityLink, setActivityLink] = useState("");
  const [activityDescription, setActivityDescription] = useState("");
  const [activityInputSummary, setActivityInputSummary] = useState("");

  const [images, setImages] = useState([]);
  const [imageCounter, setImageCounter] = useState([0]);

  const [typeOfActivityEmpty, setTypeOfActivityEmpty] = useState(false);
  const [activityDateEmpty, setActivityDateEmpty] = useState(null);
  const [activityTitleEmpty, setActivityTitleEmpty] = useState(false);
  const [activityDescriptionEmpty, setActivityDescriptionEmpty] =
    useState(false);
  const [activityInputSummaryEmpty, setActivityInputSummaryEmpty] =
    useState(false);
  const [imageEmpty, setImageEmpty] = useState(false);
  const [tagEmpty, setTagEmpty] = useState(false);
  const [invalidLink, setInvalidLink] = useState(false);

  useEffect(() => {
    fetchAllTags(); // eslint-disable-next-line
    if (editId) {
      fetchOneActivity(editId);
    }
  }, [editId]);

  const fetchOneActivity = async (activityId) => {
    setIsLoadingSave(true);
    const response = await fetchActivityDetail(activityId);
    if (response && response.status === 200 && response.data) {
      const {
        ActivityImages = [],
        ActivityTags = [],
        activityDate,
        activityType = "",
        input_summary = "",
        description = "",
        link = "",
        title = "",
      } = response.data;
      setActivityDate(moment(activityDate).format("DD/MM/YYYY"));
      setSelectedActivityDate(new Date(activityDate));
      setTypeOfActivity({ value: activityType, label: activityType });
      setActivityTitle(title);
      setActivityLink(link);
      setActivityInputSummary(input_summary);
      setActivityDescription(description);

      let finalImageCounter = [];

      const finalImages =
        ActivityImages &&
        Array.isArray(ActivityImages) &&
        ActivityImages.length > 0 &&
        ActivityImages.map((activityImage, index) => {
          finalImageCounter.push(index);
          const { img_url, id } = activityImage || {};
          const objImage = {
            image: img_url,
            activityImageId: id,
          };
          return objImage;
        });
      setImages(finalImages);
      setImageCounter(finalImageCounter);

      const finalTags =
        ActivityTags &&
        Array.isArray(ActivityTags) &&
        ActivityTags.length > 0 &&
        ActivityTags.map((activityTag) => {
          const { Tag: { id, tag_name } = {} } = activityTag || {};
          const objTag = { id, label: tag_name, value: tag_name };
          return objTag;
        });
      setTags(finalTags);
    }
    setIsLoadingSave(false);
  };

  const fetchAllTags = async () => {
    setIsLoadingSave(true);
    const response = await fetchTags();
    if (response && response.status === 200 && response.data) {
      const { data = [] } = response || {};
      const finalTags = [];
      data.forEach((el) => {
        const { tag_name, id } = el || {};
        finalTags.push({ id, label: tag_name, value: tag_name });
      });
      setTagOptions(finalTags);
      setIsLoadingSave(false);
    }
    forceUpdate();
  };

  const onDropdownChange = (val, key, flagger) => {
    if (flagger) {
      const isSameProperty = (val, tagOptions) =>
        val.value === tagOptions.value;

      const onlyInLeft = (left, right, compareFunction) =>
        left.filter(
          (leftValue) =>
            !right.some((rightValue) => compareFunction(leftValue, rightValue))
        );

      const onlyInVal = onlyInLeft(val, tagOptions, isSameProperty);
      const onlyInTagOptions = onlyInLeft(tagOptions, val, isSameProperty);

      const result = [...onlyInVal, ...onlyInTagOptions];

      let arrTagOptions = tagOptions;
      result.forEach(async (el) => {
        if (el["__isNew__"]) {
          const { label, value } = el || {};
          const createdTag = await addTag({ tag_name: value });
          if (createdTag && createdTag.status === 201 && createdTag.data) {
            arrTagOptions.push({ label, value, id: createdTag.data.id });
            setTagOptions(arrTagOptions);
            setTags([...tags, { label, value, id: createdTag.data.id }]);
          }
        }
      });
    }
    key(val);
  };

  const handleChangeInputDate = (date) => {
    setSelectedActivityDate(date);
    setActivityDate(moment(date).format("DD/MM/YYYY"));
  };

  const onInputChange = (str, setter) => {
    setter(str);
  };

  const addMoreImageInput = () => {
    const lastIndexImageCounter = imageCounter[imageCounter.length - 1];
    if (images.length === 0) {
      setShowAlertWorkshop(true);
      setWorkshopAlertMsg(
        "Alert! Please upload image first to be able to add more field"
      );
    } else {
      if (!images[lastIndexImageCounter]) {
        setShowAlertWorkshop(true);
        setWorkshopAlertMsg(
          "Alert! Please upload image first to be able to add more field"
        );
      } else {
        const lastIndexFacilitator = images[lastIndexImageCounter];
        if (!lastIndexFacilitator["image"]) {
          setShowAlertWorkshop(true);
          setWorkshopAlertMsg(
            "Alert! Please upload image first to be able to add more field"
          );
        } else {
          setShowAlertWorkshop(false);
          setWorkshopAlertMsg("");
          const tempImageCounter = imageCounter;
          const currentCounter = imageCounter.length;
          if (currentCounter < 20) {
            tempImageCounter.push(currentCounter);
            setImageCounter(tempImageCounter);
            forceUpdate();
          }
        }
      }
    }
  };

  const onImageChange = (files, index, key) => {
    if (files && files[0]) {
      const { size } = files[0] || {};
      let finalImages = images;
      let maxFileSize = 50 * 1024 * 1024; // make 50Mb max file size
      if (images.length === 0) {
        if (size >= maxFileSize) {
          finalImages.push({
            [`${key}`]: URL.createObjectURL(files[0]),
            [`imageToSave`]: files[0],
            fileName: files[0].name,
            [`isFileSizeTooLargeMsg`]: "File too large (Max: 50Mb)",
          });
        } else {
          finalImages.push({
            [`${key}`]: URL.createObjectURL(files[0]),
            [`imageToSave`]: files[0],
            fileName: files[0].name,
            [`isFileSizeTooLargeMsg`]: "",
          });
        }
      } else {
        if (size >= maxFileSize) {
          finalImages[index] = {
            ...finalImages[index],
            [`imageToSave`]: files[0],
            fileName: files[0].name,
            [`${key}`]: URL.createObjectURL(files[0]),
            [`isFileSizeTooLargeMsg`]: "File too large (Max: 50Mb)",
          };
        } else {
          finalImages[index] = {
            ...finalImages[index],
            [`imageToSave`]: files[0],
            fileName: files[0].name,
            [`${key}`]: URL.createObjectURL(files[0]),
            [`isFileSizeTooLargeMsg`]: "",
          };
        }
      }
      setImages(finalImages);
      forceUpdate();
    }
  };

  const checkAllInputs = (e) => {
    e.preventDefault();
    setIsLoadingSave(true);

    let isTypeOfActivityEmpty = false;
    let isActivityDateEmpty = false;
    let isActivityTitleEmpty = false;
    let isActivityDescriptionEmpty = false;
    let isActivityInputSummaryEmpty = false;
    let isTagEmpty = false;
    let isImageEmpty = false;
    let isLinkInvalid = false;

    if (!typeOfActivity) {
      isTypeOfActivityEmpty = true;
    }
    if (!activityDate) {
      if (!editId) {
        if (!selectedActivityDate) {
          isActivityDateEmpty = true;
        }
      } else {
        isActivityDateEmpty = true;
      }
    }
    if (!activityTitle) {
      isActivityTitleEmpty = true;
    }

    if (!activityInputSummary) {
      isActivityInputSummaryEmpty = true;
    }

    if (!activityDescription) {
      isActivityDescriptionEmpty = true;
    }

    if (tags.length <= 0) {
      isTagEmpty = true;
    }

    if (images.length <= 0) {
      isImageEmpty = true;
    } else {
      let finalImages = images;
      images.forEach((imageUploaded, index) => {
        const { image = "" } = imageUploaded || {};
        if (image) {
          finalImages[index]["emptyImage"] = false;
        } else {
          finalImages[index]["emptyImage"] = true;
          isImageEmpty = true;
        }
      });
      setImages(finalImages);
      forceUpdate();
    }

    if (activityLink) {
      const websiteUrlRegex =
        /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$/;
      if (websiteUrlRegex.test(activityLink) !== true) {
        isLinkInvalid = true;
      }
    }

    setTypeOfActivityEmpty(isTypeOfActivityEmpty);
    setActivityDateEmpty(isActivityDateEmpty);
    setActivityTitleEmpty(isActivityTitleEmpty);
    setActivityDescriptionEmpty(isActivityDescriptionEmpty);
    setActivityInputSummaryEmpty(isActivityInputSummaryEmpty);
    setImageEmpty(isImageEmpty);
    setTagEmpty(isTagEmpty);
    setInvalidLink(isLinkInvalid);

    if (
      isTypeOfActivityEmpty !== true &&
      isActivityDateEmpty !== true &&
      isActivityTitleEmpty !== true &&
      isActivityInputSummaryEmpty !== true &&
      isActivityDescriptionEmpty !== true &&
      isImageEmpty !== true &&
      isTagEmpty !== true &&
      isLinkInvalid !== true
    ) {
      handleSave();
    } else {
      setIsLoadingSave(false);
      setShowAlertWorkshop(true);
      setWorkshopAlertMsg("Please check the error fields");
    }
  };

  const handleSave = async () => {
    const data = new FormData();

    let activity_date = moment(selectedActivityDate, "YYYY-MM-DD");
    activity_date = new Date(activity_date).toISOString();

    const tagIds = [];
    tags.forEach((tag) => {
      tagIds.push(tag.id);
    });

    data.append("type_of_activity", typeOfActivity.value);
    data.append("activity_title", activityTitle);
    data.append("activity_description", activityDescription);
    data.append("activity_input_summary", activityInputSummary);
    if (activityLink) {
      data.append("activity_link", activityLink);
    }
    data.append("activity_date", activity_date);
    data.append("tagIds", JSON.stringify(tagIds));

    const activityImageIds = [];
    images.forEach((uploadImage) => {
      const { imageToSave, activityImageId } = uploadImage;
      if (imageToSave) {
        data.append("activity_images", imageToSave);
      } else {
        if (activityImageId) {
          activityImageIds.push(activityImageId);
        }
      }
    });
    data.append("activityImageIds", JSON.stringify(activityImageIds));

    try {
      let result;
      if (editId) {
        result = await editActivity(editId, data);
      } else {
        result = await addActivity(data);
      }
      if (result) {
        Swal.fire({
          customClass: {
            confirmButton: "publishButton",
            title: "publishTitle",
            popup: "publishPopup",
          },
          showCloseButton: true,
          confirmButtonColor: "#1F81DC",
          title: "Success!",
          text: editId
            ? "This activity has been succesfully edited"
            : "This activity has been succesfully created",
          confirmButtonText: "Okay, got it!",
        });
        fetchAllActivities();
        navigate(`/admin/activities`);
      }
    } catch (err) {
      const {
        activityImg = "",
        index = "",
        errorName,
        errorMsg,
        message,
      } = err.response.data || {};

      if (
        message &&
        (message === "Unauthorized" ||
          message === "Unauthenticated" ||
          message === "TokenExpiredError")
      ) {
        Swal.fire({
          position: "top-end",
          text: "Token expired, please re-login",
          showConfirmButton: false,
          timer: 1500,
          backdrop: false,
          width: "450px",
        });
        setIsLoadingSave(false);
        localStorage.removeItem("isVerified");
        localStorage.removeItem("access_token");
        localStorage.removeItem("email");
        navigate("/signIn");
      } else if (errorName === "Bad request") {
      } else if (errorName === "File too large (Max: 50Mb)") {
        Swal.fire({
          position: "top-end",
          text: errorName,
          showConfirmButton: false,
          timer: 1500,
          backdrop: false,
          width: "450px",
        });
      } else {
        Swal.fire({
          position: "top-end",
          text: "Please fill all required elements",
          showConfirmButton: false,
          timer: 1500,
          backdrop: false,
          width: "450px",
        });
      }
    } finally {
      setIsLoadingSave(false);
    }
  };

  const handleDeleteImage = (imgUrl) => {
    let finalImages = images;
    let finalImageCounter = [];
    finalImages =
      finalImages &&
      Array.isArray(finalImages) &&
      finalImages.length > 0 &&
      finalImages.filter((img) => img.image !== imgUrl);
    finalImages.forEach((img, index) => {
      finalImageCounter.push(index);
    });
    if (finalImageCounter.length === 0) {
      finalImageCounter = [0];
    }
    setImageCounter(finalImageCounter);
    setImages(finalImages);
  };

  return (
    <div className="adminPostList">
      {isLoadingSave ? null : (
        <div className="adminPostListTitleContainer">
          <div className="adminPostListTitle">
            <p>{editId ? "Edit Activity" : "Add New Activity"}</p>
          </div>
        </div>
      )}
      {isLoadingSave ? (
        <div
          style={{
            width: "75%",
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            marginTop: "5em",
          }}
        >
          <Lottie options={lottieOptions} height={200} width={400} />
          <h4
            style={{
              color: "#0D4C86",
            }}
          >
            LOADING
          </h4>
          <p
            style={{
              color: "#0D4C86",
            }}
          >
            Processing your request, please wait...
          </p>
        </div>
      ) : (
        <div className="adminPostAdd">
          <form>
            <div className="typeOfWorkAndTagInput">
              <div className="eachContainer">
                <div className="eachLabel">Activity type</div>
                <WorkshopDropdownSelect
                  placeholder="Select activity"
                  options={[
                    { value: "workshop", label: "workshop" },
                    { value: "in house training", label: "in house training" },
                    { value: "general activity", label: "general activity" },
                  ]}
                  selectStyle={{
                    height: "50px",
                    borderRadius: "40px",
                    fontSize: "15px",
                    padding: "5px",
                    borderColor: "#0D4C86",
                  }}
                  optionStyle={{
                    backgroundColor: "#0D4C86",
                    fontSize: "15px",
                    color: "#FFFFFF",
                  }}
                  onChange={(e) => onDropdownChange(e, setTypeOfActivity)}
                  value={typeOfActivity}
                />
                {typeOfActivityEmpty && !typeOfActivity ? (
                  <div className="errorMessage">
                    <p>This field is required</p>
                  </div>
                ) : null}
              </div>
              <div className="eachContainer">
                <div className="eachLabel">Date</div>
                <DatePicker
                  selected={
                    selectedActivityDate ? selectedActivityDate : new Date()
                  }
                  onChange={(date) => handleChangeInputDate(date)}
                  customInput={
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "#ffffff",
                        border: "1px solid #0d4c86",
                        borderRadius: "40px",
                        height: "50px",
                        fontSize: "15px",
                        borderColor: "#0D4C86",
                        padding: "1em",
                      }}
                    >
                      <div>
                        {activityDate ? `${activityDate}` : "Select date"}
                      </div>
                      <ArrowDownIcon />
                    </div>
                  }
                  showMonthDropdown
                  showYearDropdown
                  todayButton="Today"
                  dropdownMode="select"
                  dateFormat="dd/MM/yyyy"
                  autoComplete="off"
                />
                {activityDateEmpty && !activityDate ? (
                  <div className="errorMessage">
                    <p>This field is required</p>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="adminPostInput">
              <div className="labelForDescription">
                <div className="eachLabel">Title</div>
              </div>
              <textarea
                required
                name="workshopTitle"
                type="text"
                className="xSmallInputBox"
                placeholder="Please enter title here..."
                value={activityTitle}
                onChange={({ target: { value } }) =>
                  onInputChange(value, setActivityTitle)
                }
              ></textarea>
              {activityTitleEmpty && !activityTitle ? (
                <div className="errorMessage">
                  <p>This field is required</p>
                </div>
              ) : null}
            </div>
            <div className="adminPostInput">
              <div className="labelForDescription">
                <div className="eachLabel">Input Summary</div>
                {/* <div className="secondLabel">
                  This description summary will appear on each image
                </div> */}
              </div>
              <textarea
                required
                name="activityInputSummary"
                type="text"
                className="bigInputBox"
                placeholder="Please enter the summary here..."
                value={activityInputSummary}
                onChange={({ target: { value } }) =>
                  onInputChange(value, setActivityInputSummary)
                }
              ></textarea>
              {activityInputSummaryEmpty && !activityInputSummary ? (
                <div className="errorMessage">
                  <p>This field is required.</p>
                </div>
              ) : null}
            </div>
            <div className="adminPostInput">
              <div className="labelForDescription">
                <div className="eachLabel">Description</div>
                {/* <div className="secondLabel">
                  This description summary will appear on each image
                </div> */}
              </div>
              <textarea
                required
                name="activityDescription"
                type="text"
                className="bigInputBox"
                placeholder="Please enter the description here..."
                value={activityDescription}
                onChange={({ target: { value } }) =>
                  onInputChange(value, setActivityDescription)
                }
              ></textarea>
              {activityDescriptionEmpty && !activityDescription ? (
                <div className="errorMessage">
                  <p>This field is required.</p>
                </div>
              ) : null}
            </div>
            {imageCounter &&
              Array.isArray(imageCounter) &&
              imageCounter.length > 0 &&
              imageCounter.map((counter) => {
                return (
                  <InputUploadImages
                    key={counter}
                    counter={counter}
                    firstInput={counter < 1 ? true : false}
                    images={images}
                    addMoreImageInput={addMoreImageInput}
                    addMoreIcon={addMoreIcon}
                    uploadImageBtn={uploadImageBtn}
                    iconChangeImage={iconChangeImage}
                    onImageChange={onImageChange}
                    imageEmpty={imageEmpty}
                    handleDeleteImage={handleDeleteImage}
                    deleteIcon={DeleteIcon}
                  />
                );
              })}
            <div className="adminPostInput">
              <div className="eachLabel">Tags</div>
              <WorkshopDropdownSelect
                placeholder="Please input tags here..."
                options={tagOptions}
                selectStyle={{
                  borderRadius: "40px",
                  fontSize: "15px",
                  padding: "5px",
                  borderColor: "#0D4C86",
                }}
                optionStyle={{
                  backgroundColor: "#0D4C86",
                  fontSize: "15px",
                  color: "#FFFFFF",
                }}
                createAble={true}
                isMulti={true}
                onChange={(e) => onDropdownChange(e, setTags, true)}
                value={tags}
              />
              {tagEmpty && tags.length <= 0 ? (
                <div className="errorMessage">
                  <p>This field is required.</p>
                </div>
              ) : null}
            </div>
            <div className="adminPostInput">
              <div className="labelForDescription">
                <div className="eachLabel">Link</div>
              </div>
              <textarea
                required
                name="activityLink"
                type="text"
                className="xSmallInputBox"
                placeholder="Please input the supporting link here..."
                value={activityLink}
                onChange={({ target: { value } }) =>
                  onInputChange(value, setActivityLink)
                }
              ></textarea>
              {invalidLink ? (
                <div className="errorMessage">
                  <p>Please input the correct form of the website URL.</p>
                </div>
              ) : null}
            </div>
            <div className="adminPostButtonContainer">
              <div>
                <span
                  className="postCancelButton btn"
                  onClick={() => navigate("/admin/activities")}
                >
                  Cancel
                </span>
              </div>
              <div>
                <button
                  className="postSaveButton btn"
                  onClick={(e) => checkAllInputs(e)}
                >
                  {isLoadingSave ? (
                    <span>
                      <Loader
                        type="spin"
                        color="black"
                        height="25px"
                        width="25px"
                      />
                    </span>
                  ) : (
                    <span>Save</span>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default ActivitiesForm;
